import React from "react";

export default function Credit() {
  return (
    <div className="row credit">
      <div className="col">
        <span className="name">
          <a
            href="https://github.com/ssrome/weather-react"
            rel="noreferrer"
            target="_blank"
          >
            Open-source code
          </a>{" "}
          by Sabrina Samuel
        </span>
      </div>
    </div>
  );
}
